import Vue from 'vue'

if (process.client) {
  import('vue-notification').then((module) => {
    Vue.use(module.default)
  })
}
